module.exports = __webpack_public_path__ + "img/w-x@4x.6d950236.png";